export default __webpack_public_path__ + "assets/images/09f2e4f33d12cebbd76d9950adf08b9b.png";